export default "__VITE_ASSET__BXIs$RN9__"